import { create } from 'zustand';

type Store = {
  open: boolean;
  setOpen: (isOpen: boolean) => void;
};

export const useSwapTokenCtaPopoverStore = create<Store>((set) => ({
  open: false,
  setOpen(open) {
    set({
      open,
    });
  },
}));
